import script from "./dpointsDeduc.vue?vue&type=script&setup=true&lang=js"
export * from "./dpointsDeduc.vue?vue&type=script&setup=true&lang=js"

import "./dpointsDeduc.vue?vue&type=style&index=0&id=3f3dfdbc&lang=scss"

const __exports__ = script;

export default __exports__